// Single source of truth for the backend API base URL.
// Override per environment with REACT_APP_API_URL (set at build time).
export const API = process.env.REACT_APP_API_URL || 'https://reddit-rm-tool-production.up.railway.app';

// axios config for org-scoped endpoints: the org switcher's organisation. The
// server only honours it for a super admin; everyone else gets their own org.
export const withOrg = (orgId, config = {}) => (orgId ? { ...config, params: { ...(config.params || {}), organization_id: orgId } } : config);
